const PropTypes = require('prop-types');
const React = require('react');
const { each, filter } = require('lodash');

const ProductSearchForm = require('../product_search_form/product_search_form.jsx');
const BundleInfoForm = require('./bundle_info_form.jsx');
const ProductDetails = require('./product_details.jsx');
const Loading = require('../shared/loading.jsx');
const ProductBundlePreview = require('./product_bundle_preview.jsx');
const CSRFForm = require('../shared/csrf_form.jsx');
const BundledProductValidator = require('./bundled_product_validator.js');

class ProductBundleForm extends React.Component {
  static propTypes = {
    productBundlePath: PropTypes.string.isRequired,
    productBundlesPath: PropTypes.string.isRequired,
    userCurrency: PropTypes.string.isRequired,
    deleteProductBundlePath: PropTypes.string,
    disableSearchFormDebounce: PropTypes.bool,
  };

  state = {
    productBundle: null,
    removedBundledProducts: [],
    inputValue: '',
  };

  componentDidMount() {
    this.fetchProductBundle();
  }

  submitText = () => {
    if (this.state.productBundle.id) {
      return I18n.t('js.productBundles.bundleInfoForm.updateBundle');
    }
    return I18n.t('js.productBundles.bundleInfoForm.createBundle');
  };

  deleteButton = () => {
    if (this.state.productBundle.id) {
      return (
        <div className="g-col-3 offset-3 align-right">
          <a href={this.props.deleteProductBundlePath} className="btn wide" data-method="delete" data-confirm={I18n.t('js.productBundles.bundleInfoForm.confirm')}>{I18n.t('js.productBundles.bundleInfoForm.deleteBundle')}</a>
        </div>
      );
    }
  };

  fetchProductBundle = () => {
    Reverb.APIRequest.V3.get(this.props.productBundlePath)
      .then((response) => {
        this.setState({
          productBundle: response,
        });
      });
  };

  productSelected = (product) => {
    const newListing = product;
    newListing.original_price = product.price;
    newListing.price = { amount: '0' };
    this.state.productBundle.bundled_products.push({ listing: newListing });
    this.setState({
      productBundle: this.state.productBundle,
      searching: false,
      inputValue: '',
    });
  };

  removeProduct = (index) => {
    const removedBundledProduct = this.state.productBundle.bundled_products[index];
    if (removedBundledProduct.id) {
      this.state.removedBundledProducts.push(removedBundledProduct);
    }
    this.state.productBundle.bundled_products.splice(index, 1);
    this.setState({ productBundle: this.state.productBundle, removedBundledProducts: this.state.removedBundledProducts });
  };

  removedBundledProducts = () => this.state.removedBundledProducts.map((bundledProduct, index) => (
    <div key={bundledProduct.id}>
      <input type="hidden" value={bundledProduct.id} name={`product_bundle[bundled_products_attributes][${index + this.state.productBundle.bundled_products.length}][id]`} />
      <input type="hidden" value="1" name={`product_bundle[bundled_products_attributes][${index + this.state.productBundle.bundled_products.length}][_destroy]`} />
    </div>
  ));

  renderPreview = () => {
    if (!this.hasListings()) { return false; }

    return (
      <div>
        <h4 className="heading-4 mt-1 mb-half">{I18n.t('js.productBundles.productBundleForm.preview')}</h4>
        <div className="module bd-rounded mb-1">
          <ProductBundlePreview productBundle={this.state.productBundle} />
        </div>
      </div>
    );
  };

  anyBundledProducts = callback => filter(this.state.productBundle.bundled_products, callback).length;

  hasListings = () => this.anyBundledProducts(bundledProduct => bundledProduct.listing);

  validateForm = () => {
    each(this.state.productBundle.bundled_products, (bundledProduct) => {
      new BundledProductValidator(bundledProduct).validate();
    });
    this.setState({ productBundle: this.state.productBundle });
  };

  errorsPresent = () => this.anyBundledProducts(bundledProduct => bundledProduct.errorMessage);

  handleSubmit = (event) => {
    this.validateForm();
    if (this.errorsPresent()) {
      event.preventDefault();
    }
  };

  bundledProductChanged = (bundledProduct, index) => {
    this.state.productBundle.bundled_products[index] = bundledProduct;
    this.setState({ productBundle: this.state.productBundle });
  };

  addListing = () => {
    this.setState({ searching: true });
  };

  renderBundledProducts = () => this.state.productBundle.bundled_products.map((bundledProduct, index) => (
    <BundleInfoForm
      bundledProduct={bundledProduct}
      remove={this.removeProduct}
      userCurrency={this.props.userCurrency}
      bundledProductChanged={this.bundledProductChanged}
      index={index}
      key={index}
    />
  ));

  currentListingIds = () => {
    const currentListingIds = this.state.productBundle.bundled_products.map(bundledProduct => bundledProduct.listing.id);
    currentListingIds.push(this.state.productBundle.main_listing.id);

    return currentListingIds;
  };

  handleChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  renderSearchForm = () => {
    if (!this.hasListings() || this.state.searching) {
      return (
        <div className="module">
          <ProductSearchForm
            productSelected={this.productSelected}
            currentListingIds={this.currentListingIds()}
            labelText={I18n.t('js.productBundles.productSearchForm.label')}
            onChange={this.handleChange}
            disableDebounce={this.props.disableSearchFormDebounce}
          />
        </div>
      );
    }
  };

  formButtons = () => {
    if (this.hasListings()) {
      return (
        <div className="g-container mt-1">
          <div className="g-col-3 g-col-mobile-12 mobile-mb-1">
            <input type="submit" value={this.submitText()} className="btn btn-primary wide" />
          </div>
          <div className="g-col-3 g-col-mobile-12 mobile-mb-1">
            <a onClick={this.addListing} className="btn wide">{I18n.t('js.productBundles.productBundleForm.addItem')}</a>
          </div>
          {this.deleteButton()}
        </div>
      );
    }
  };

  render() {
    if (!this.state.productBundle) {
      return (
        <div className="ptb-6">
          <Loading />
        </div>
      );
    }

    return (
      <CSRFForm method="POST" action={this.props.productBundlesPath} onSubmit={this.handleSubmit}>
        <div className="g-container pb-6">
          <div className="g-col-8 g-col-mobile-12 mobile-mb-2">
            <div className="module bd-rounded bundle-form mb-1">
              <h4 className="heading-3 mb-half">{I18n.t('js.productBundles.productBundleForm.mainListing')}</h4>
              <ProductDetails product={this.state.productBundle.main_listing} />
              <input type="hidden" value={this.state.productBundle.main_listing.id} name="product_bundle[main_listing_id]" />
            </div>
            {this.removedBundledProducts()}
            {this.renderBundledProducts()}
            {this.renderSearchForm()}
            {this.formButtons()}
          </div>
          <div className="g-col-4 g-col-mobile-12">
            <h4 className="heading-4 mb-half">{I18n.t('js.productBundles.productBundleForm.about')}</h4>
            <ul className="fa-ul small">
              <li>
                <span className="fa fa-check fa-li color-green" />
                {I18n.t('js.productBundles.productBundleForm.advertised')}
              </li>
              <li>
                <span className="fa fa-check fa-li color-green" />
                {I18n.t('js.productBundles.productBundleForm.discount')}
              </li>
              <li>
                <span className="fa fa-check fa-li color-green" />
                {I18n.t('js.productBundles.productBundleForm.directCheckout')}
              </li>
              <li>
                <span className="fa fa-check fa-li color-green" />
                <a href={this.props.learnMoreBundlePath} target="blank">{I18n.t('js.productBundles.productBundleForm.learnMore')}</a>
              </li>
            </ul>
            {this.renderPreview()}
          </div>
        </div>
      </CSRFForm>
    );
  }
}

module.exports = ProductBundleForm;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/product_bundle_form.jsx